export type WebTrabajo = {
  client: string;
  rubro: string;
  frase?: string;
  image: string;
};

export type AgenteTrabajo = {
  client: string;
  rubro: string;
  queSeHizo: string;
  hasProof: boolean;
  testimonio?: { quote: string; name: string; business: string };
};

const IMG = "https://assets.cdn.filesafe.space/UmeUICnWy44Ung9XrMjl/media/";

export const websTrabajos: WebTrabajo[] = [
  {
    client: "Arregui Premium",
    rubro: "Distribución de carne · CABA y Zona Norte",
    frase: "Pedidos de lista de precios que antes se perdían en el WhatsApp.",
    image: IMG + "6a9ec6c0a423db57772d23da.png",
  },
  {
    client: "Materiales Hoy",
    rubro: "Corralón de materiales",
    frase: "Presupuestos y pedidos por WhatsApp, con seguimiento.",
    image: IMG + "6a9ec6cbbcef8b5f2c25e9fc.png",
  },
  {
    client: "TreeTecno",
    rubro: "Mayorista de tecnología",
    frase: "Catálogo mayorista y consulta directa.",
    image: IMG + "6a9ec6d14793a2d512ad47a1.png",
  },
  {
    client: "Bass Objetos",
    rubro: "Deco y jardines verticales",
    frase: "Proyectos a medida con cotización rápida.",
    image: IMG + "6a9ec6c3968770b81c48aa45.png",
  },
  {
    client: "Half Socks",
    rubro: "Fábrica de indumentaria deportiva",
    frase: "La cara de la fábrica para revendedores.",
    image: IMG + "6a9ec6c8a4ea811589e47c6a.png",
  },
  {
    client: "BJB Repuestos",
    rubro: "Taller mecánico y repuestos",
    frase: "Turnos de taller y venta de repuestos en un solo lugar.",
    image: IMG + "6a9ec6c5968770b81c48aa7d.png",
  },
  {
    client: "Sicurella Estética",
    rubro: "Centro de estética · Pilar",
    frase: "Reserva de turnos y tratamientos.",
    image: IMG + "6a9ec6cfee97c4169461bf08.png",
  },
  {
    client: "Consultorios Fika",
    rubro: "Alquiler de consultorios paramédicos · Palermo",
    frase: "Un espacio profesional que se ve profesional.",
    image: IMG + "6a9ec6c6a423db57772d2444.png",
  },
  {
    client: "ArdA Pet Food",
    rubro: "Alimento natural para perros",
    frase: "Plan personalizado por perro en un minuto.",
    image: IMG + "6a9ec6c0968770b81c48a9ef.png",
  },
  {
    client: "Pilar Fresh",
    rubro: "Verdulería / fresh market · Pilar",
    frase: "Fresco y cerca, con pedido por WhatsApp.",
    image: IMG + "6a9ec6cb355bf4eb55d91e97.png",
  },
  {
    client: "AstrologíaSI",
    rubro: "Escuela de astrología",
    frase: "Formación con inscripción online.",
    image: IMG + "6a9ec6c261d6b4accd476315.png",
  },
  {
    client: "Uruz Martial Arts",
    rubro: "Artes marciales",
    frase: "Clases y planes, con reserva directa.",
    image: IMG + "6a9ec6d1b69081a31c67ed1f.png",
  },
  {
    client: "La Juanita Studio",
    rubro: "Estudio de DJs y productores musicales",
    frase: "Programas y alquiler de cabinas.",
    image: IMG + "6a9ec6cabcef8b5f2c25e9c6.png",
  },
  {
    client: "ViMugica",
    rubro: "Marca personal · podcast",
    frase: "Ideas convertidas en proyectos.",
    image: IMG + "6a9ec6d2ee97c4169461bf76.png",
  },
  {
    client: "Tato Ads",
    rubro: "Agencia de e-commerce (partner)",
    frase: "El método de escalado, en una página.",
    image: IMG + "6a9ec6d0355bf4eb55d91f15.png",
  },
  {
    client: "Puro Escabio",
    rubro: "Distribuidora de bebidas",
    frase: "De un garaje a más de 13 locales.",
    image: IMG + "6a9ec6cda423db57772d2551.png",
  },
  {
    client: "Reyes del Escabio",
    rubro: "Bebidas por mayor y menor",
    image: IMG + "6a9ec6ceb69081a31c67ece3.png",
  },
  {
    client: "Hive Desarrollos",
    rubro: "Desarrollos inmobiliarios",
    image: IMG + "6a9ec6c9a2de8f8e8fbb7ed1.png",
  },
];

export const agentesTrabajos: AgenteTrabajo[] = [
  {
    client: "Munayki Estética",
    rubro: "Clínica estética multi-sede",
    queSeHizo:
      "Agente que atiende Recoleta y Quilmes, deriva por sede, agenda turnos. Recordatorios de turno automáticos y campaña de reseñas.",
    hasProof: true,
  },
  {
    client: "BJB Repuestos",
    rubro: "Taller mecánico y repuestos",
    queSeHizo:
      "Agente calificador que separa consulta de taller de consulta de repuesto y deriva.",
    hasProof: true,
  },
  {
    client: "Half Socks",
    rubro: "Fábrica de indumentaria",
    queSeHizo:
      "Agente de atención a revendedores + FAQ + formulario web de alta.",
    hasProof: true,
  },
  {
    client: "Arregui Premium",
    rubro: "Distribución de carne",
    queSeHizo: "Agente con reglas de derivación y acciones sobre el CRM.",
    hasProof: true,
    testimonio: {
      quote:
        "Implementar CreceLocal fue una de las mejores decisiones que tomé para mi negocio.",
      name: "Gonzalo Arregui",
      business: "Arregui Premium",
    },
  },
  {
    client: "TreeTecno",
    rubro: "Mayorista de tecnología",
    queSeHizo:
      "Agente súper-calificador con pipeline y calendarios de seguimiento.",
    hasProof: false,
  },
  {
    client: "Marketfull",
    rubro: "Mayorista",
    queSeHizo: "Agente con catálogo de combos y matriz de envíos por zona.",
    hasProof: false,
  },
  {
    client: "Materiales Hoy",
    rubro: "Corralón",
    queSeHizo: "Agente calificador de presupuestos con auditoría de precios.",
    hasProof: false,
  },
  {
    client: "Palermo Materiales",
    rubro: "Corralón",
    queSeHizo: "Agente de atención + pedido de reseñas post-compra.",
    hasProof: false,
  },
  {
    client: "Pilar Fresh",
    rubro: "Fresh market",
    queSeHizo:
      "Agente con el tono de la marca sobre WhatsApp, Instagram y Facebook, más ficha de Google.",
    hasProof: false,
  },
  {
    client: "Clover Home",
    rubro: "Deco y hogar",
    queSeHizo: "Agente de atención con derivación.",
    hasProof: false,
  },
  {
    client: "Flux",
    rubro: "Logística",
    queSeHizo: "Agente de atención y calificación.",
    hasProof: false,
  },
  {
    client: "Fresh",
    rubro: "Rubro a confirmar",
    queSeHizo: "Agente de atención + bot de campañas de anuncios.",
    hasProof: false,
  },
  {
    client: "Ropa Lenic",
    rubro: "Indumentaria",
    queSeHizo: "Agente de atención a clientes.",
    hasProof: false,
  },
  {
    client: "Hive Desarrollos",
    rubro: "Inmobiliaria",
    queSeHizo:
      "Agente que califica consultas de proyectos de pozo y las deriva.",
    hasProof: false,
    testimonio: {
      quote:
        "En 6 meses se reactivó la base y vendimos 12 departamentos. Pensábamos que teníamos que seguir metiendo pauta pero los clientes ya los teníamos.",
      name: "Facundo Stagnaro",
      business: "Hive Desarrollos",
    },
  },
];

export const teaserTrabajos = websTrabajos.slice(0, 6);
